import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { styled } from '@mui/material/styles';
import { Box, IconButton, Typography, Grid, Stack, Card, CardContent, Divider, } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import { useLocation, useNavigate } from 'react-router-dom';
// import AssetVideoPlayer from 'portal/common/asset/AssetVideoPlayer';
import { useStore, } from '@mcn-platform/models';
import CourseHeadline from '../../item/card/ItemHeadline';
import CourseInfo from '../../item/card/ItemInfo';
import ItemInstructors from '../../item/card/ItemInstructors';
import PanelTitle from '../../item/LandingPageTabs/PanelTitle';
import ItemCallToAction from '../../item/card/enrollPrice/CallToAction';
import AssetImage from '../../common/asset/AssetImage';
import AssetVideoPlayer from '../../common/asset/AssetVideoPlayer';
import PlaceHolder from '../../common/PlaceHolder';
import { configLandingPage } from '../../common/portalConfig';
import { getCourseData } from '../../item/getData';
const StyledDivider = styled(Divider)(() => ({
    borderBottomWidth: 1,
}));
const ShareButtons = ({ handleAdd, handleShare }) => {
    const hideEndIcon = false;
    if (hideEndIcon) {
        return (_jsxs(Stack, { direction: "row", spacing: 1.5, children: [_jsx(IconButton, { onClick: handleAdd, sx: { width: 35, height: 35, border: (theme) => `2px solid ${theme.palette.primary.main}` }, "aria-label": "add button", children: _jsx(AddIcon, { fontSize: "small", color: "primary" }) }), _jsx(IconButton, { onClick: handleShare, sx: { width: 35, height: 35, border: (theme) => `2px solid ${theme.palette.primary.main}` }, "aria-label": "add button", children: _jsx(ReplyAllIcon, { fontSize: "small", color: "primary" }) })] }));
    }
    return null;
};
const CourseSummary = ({ courseID, 
// action,
settings: { showVideo, showCourseInfo, showCourseHeadline, showCourseDesc, showOfferedBy, showInstructor, showPriceButton, showActionButton,
// showEnrollButton,
 }, editData, }) => {
    const { currentPortal: portal, getOrLoad, getItemProgress } = useStore();
    const navigate = useNavigate();
    const location = useLocation();
    if (editData && !courseID) {
        return (_jsx(PlaceHolder, { placeHolderName: "Select course to see preview" }));
    }
    if (!courseID) {
        return null;
    }
    const course = getOrLoad('course', courseID);
    const courseProgress = getItemProgress(course);
    const { name, headline, description, 
    /* avgRating, reviews, */
    companyName, price, sellPrice, } = course;
    const handleAdd = () => { };
    const handleShare = () => { };
    const { buttonLabel, action, instructorAction, showPrice, } = configLandingPage(portal, course, courseProgress, navigate, location, '.');
    return (_jsx(Card, { sx: { boxShadow: '0 0 18px 0 rgba(9, 32, 46, 0.2)' }, children: _jsx(CardContent, { children: _jsxs(Grid, { container: true, columnSpacing: 2.5, children: [_jsxs(Grid, { item: true, sm: 12, md: 7, order: { xs: 2, md: 0 }, children: [_jsx(PanelTitle, { title: name, endIcon: (_jsx(ShareButtons, { handleAdd: handleAdd, handleShare: handleShare })), className: "courseTitleLandingPage", rootStyle: { mb: 0 }, wrapperStyle: { maxHeight: 40 }, dividerStyle: {
                                    borderBottomWidth: '2px',
                                    margin: '25px 0px 9px',
                                    borderColor: (t) => t.portal?.site?.lineColor,
                                } }), _jsxs(Stack, { spacing: 1, divider: _jsx(StyledDivider, {}), children: [showCourseInfo && (_jsx(Stack, { direction: "row", justifyContent: "space-between", children: showCourseInfo && (_jsx(CourseInfo, { item: course })) })), _jsx(Stack, { children: _jsx(CourseHeadline, { headline: showCourseHeadline && headline, description: showCourseDesc && description, size: "medium", isShowMore: showCourseDesc }) }), companyName && showOfferedBy && (_jsx(Stack, { direction: "row", children: _jsx(Typography, { variant: "body1", className: "description", sx: {
                                                marginY: 'auto !important',
                                                // marginLeft: '18px !important',
                                            }, children: companyName && (_jsxs(Typography, { component: "span", variant: "body1", fontWeight: "fontWeightBold", children: ["Offered By:\u00A0", companyName] })) }) })), showInstructor && course.instructors.length && (_jsx(ItemInstructors, { showAvatar: true, size: "large", instructors: course.instructors, instructorAction: instructorAction })), _jsx(ItemCallToAction, { showPrice: showPriceButton && showPrice, showButton: showActionButton, price: price, sellPrice: sellPrice, action: action, buttonLabel: buttonLabel, isFlexGrow: true })] })] }), _jsx(Grid, { item: true, sm: 12, md: 5, order: { xs: 1, md: 0 }, children: showVideo && (_jsx(Box, { sx: { width: 'auto' }, children: course.promoVideo ? (_jsx(AssetVideoPlayer, { aspectRatio: "4:3", asset: course.promoVideo, assetPoster: course.posterImage || course.courseImage, seekPosition: undefined, seekTrigger: undefined, onProgress: () => { }, onEnd: () => (false), onPause: () => { }, onDuration: () => { }, handleNextPrevious: () => { }, disableSeekAhead: false })) : (_jsx(AssetImage, { asset: course.courseImage, size: "thumb400w", customStyle: { width: '100%', objectFit: 'cover' } })) })) })] }) }) }));
};
CourseSummary.getData = async ({ courseID }, store) => {
    console.log('Adding item to preload', courseID);
    if (!courseID) {
        console.log('No item to load for CourseSummary card');
        return 'ok';
    }
    await getCourseData(store, courseID);
    // console.log('imageAsset', imageAsset);
    return 'ok';
};
CourseSummary.defaultProps = {
    settings: {
        showVideo: true,
        showCourseInfo: true,
        showCourseHeadline: true,
        showCourseDesc: true,
        showOfferedBy: true,
        showInstructor: true,
        showEnrollButton: true,
        showPriceButton: true,
        showActionButton: true,
    },
    editData: undefined,
};
CourseSummary.meta = {
    group: 'design',
    name: 'Course Summary Card',
    description: 'Component displays the details of a course',
    props: [
        {
            key: 'courseID',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.showVideo',
            name: 'Show Image or Video',
            type: 'boolean',
            description: 'Show the intro video on the card',
        },
        {
            key: 'settings.showCourseInfo',
            name: 'Show Course Info Bar',
            type: 'boolean',
            description: 'Show the course info on the card',
        },
        {
            key: 'settings.showCourseHeadline',
            name: 'Show Course Headline',
            type: 'boolean',
            description: 'Show the course headline on the card',
        },
        {
            key: 'settings.showCourseDesc',
            name: 'Show Course Description',
            type: 'boolean',
            description: 'Show the course description on the card',
        },
        {
            key: 'settings.showOfferedBy',
            name: 'Show Offered By',
            type: 'boolean',
            description: 'Show the order by company name on the card',
        },
        {
            key: 'settings.showInstructor',
            name: 'Show Instructor',
            type: 'boolean',
            description: 'Show the instructor field on the card',
        },
        {
            key: 'settings.showPriceButton',
            name: 'Show Price',
            type: 'boolean',
            description: 'Show the price field on the card',
        },
        {
            key: 'settings.showActionButton',
            name: 'Show Call to Action Button',
            type: 'boolean',
            description: 'Show the instructor field on the card',
        },
        // {
        //   key: 'settings.showEnrollButton',
        //   name: 'Show Enroll Button',
        //   type: 'boolean',
        //   description: 'Show the enroll button on the card',
        // },
    ],
    defaultConfig: {
        type: 'component',
        component: 'CourseSummary',
        props: {
            courseID: '@courseID',
            handleEnroll: '@enrollAction',
            settings: {
                showVideo: true,
                showCourseInfo: true,
                showCourseHeadline: true,
                showOfferedBy: true,
                showInstructor: true,
                showActionButton: true,
                showCourseDesc: true,
                showPriceButton: true,
                // showPrice: true,
                // showEnrollButton: true,
            },
        },
    },
};
export default observer(CourseSummary);
//# sourceMappingURL=CourseSummary.js.map